export const parseEnumLabel = (name: string): string => {
    if (!name) return ""
    const label = name.replace(/___/g, "/").replace(/__/g, "-").replace(/_/g, " ")
    return label
}
